import axiosInstance from '../axiosInterceptor/axiosInstance'

const getUserData = async (config) => {
  const url = '/users/me'
  const response = await axiosInstance.get(url, config)
  return response?.data
}

export default getUserData
